import { ISelectOption } from '@private/components';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IGoogleFont } from 'api/merchantTerminalThemes/types';
import { INullable } from 'utils/types';

export interface IGoogleState {
  fontsOptions: INullable<ISelectOption[]>;
  fontsWeightsMap: INullable<Record<string, string[]>>;
  saveDate: INullable<string>;
}

const initialState: IGoogleState = {
  fontsOptions: null,
  fontsWeightsMap: null,
  saveDate: null,
};

export const googleSlice = createSlice({
  initialState,
  name: 'google',
  reducers: {
    saveGoogleFonts: (state, action: PayloadAction<IGoogleFont[]>) => {
      const options: IGoogleState['fontsOptions'] = [];
      const map: IGoogleState['fontsWeightsMap'] = {};

      action.payload.forEach((item) => {
        options.push({
          label: item.family,
          value: item.value,
        });
        map[item.family] = item.variants;
      });
      state.fontsOptions = options;
      state.fontsWeightsMap = map;
      state.saveDate = new Date().toISOString();
    },
  },
});

export const { saveGoogleFonts } = googleSlice.actions;
